// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"848":"5eb18194","945":"cba30181"}[chunkId] + ".chunk.js";
};